import Vue from "vue";
import { NavigationGuard, Route } from "vue-router";

/**
 * Implicit On navigation guard requires the next route to specify
 * that it does not require auth before checking authentication status
 * of the user.
 */

const redirectRoute = (isLoggedIn: boolean, to: Route, next: Function) => {
  if (!isLoggedIn) {
    if (to.name === "Login") {
      return next();
    } else {
      const redirectPath = to.path;
      if (redirectPath === "/logged_in")
        return next({ path: "/login#redirect" });
      else
        return next({ path: `/login?redirect_path=${redirectPath}#redirect` });
    }
  } else if (isLoggedIn && to.name === "Login") {
    return next({ path: "/logged_in#redirect" });
  } else return next();
};

const navigationGuard: NavigationGuard = async (to, from, next) => {
  const fullPath = to.fullPath;
  if (
    (!to.meta.requiresAuth && to.name !== "Login") ||
    fullPath.includes("#redirect")
  ) {
    return next();
  } else {
    await Vue.$authentication.initLiff();
    const openID = Vue.$authentication.openID;
    const fullPath = to.fullPath;

    if (fullPath.includes("#redirect")) {
      return next();
    }

    if (openID) {
      const isLoggedIn = await Vue.$authentication.checkLoggedIn();
      return redirectRoute(isLoggedIn, to, next);
    }
  }
};

export default navigationGuard;
